export const RADIO_PERFIL_TITLE = 'Perfil';
export const CAMPO_PERFIL_TITLE = 'Perfil do Usuário';
export const RADIO_USUARIO_TITLE = 'Usuário';
export const CAMPO_USUARIO_TITLE = 'Nome do Usuário';
export const ERROR_COMPARAR_PERMISSOES_EXCEPTION = 'Selecione um Perfil ou Usuário para comparar as permissões';
export const ERROR_APLICAR_PERMISSOES_EXCEPTION = 'Selecione um Perfil ou Usuário para aplicar as permissões';
